import React, { useEffect, useState } from 'react';
import moment from 'moment';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

export default function TabelaVeiculos({ veiculos = [], editarVeiculo = null, removerVeiculo = null, paging = true, title = "", search = false, ficha }) {
    const [veiculosConvertidos, setVeiculosConvertidos] = useState([]);

    //ajusta a lista de veiculos para ser apresentada na tabela
    function formatVeiculos() {
        const _veiculos = veiculos.map(veiculo => {
            veiculo.implemento = { ...veiculo.implemento };
            veiculo.modalidades = veiculo.modalidades.map(modalidade => {
                return { ...modalidade };
            })
            return { ...veiculo };
        });
        setVeiculosConvertidos(_veiculos.map(value => {
            value.vistoria = moment(value.vistoria).format("DD/MM/YYYY");
            value.validade = moment(value.validade).format("DD/MM/YYYY");
            if (typeof value.implemento != "string") {
                value.implemento = value.implemento.descricao;
            }
            if (typeof value.modalidades != "string") {
                value.modalidades = value.modalidades.map(value => value.descricao).toString();
            }
            return value;
        }));
    }

    //executa assim que o componente é iniciado
    useEffect(() => {
        formatVeiculos();
    }, [veiculos]);

    //Ações da tabela de listagem de veiculos
    const actions = [actionsTable.editar(editarVeiculo), (rowData, actionsStyle) => {
        if (!rowData.id) {
            return actionsTable.remover(removerVeiculo)
        } else {
            return null;
        }
    }];

    //cabeçalhos para a tabela de veiculos
    const headersTabelaVeiculos = [
        { value: "Placa", objectValue: "placa", align: "left" },
        { value: "Modalidades de coleta", objectValue: "modalidades", align: "left" },
        { value: "Tipo de implemento", objectValue: "implemento", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Data da vistoria", objectValue: "vistoria" },
        { value: "Validade", objectValue: "validade" },
    ]
    if (!ficha) {
        return (
            <TabelaListagem actions={actions} title={title} headers={headersTabelaVeiculos} items={veiculosConvertidos} options={{ print: false, search: true, pagination: paging }} />
        )
    }
    return (
        <TabelaListagemFichas title={title} headers={headersTabelaVeiculos} items={veiculosConvertidos} paging={paging} />
    )
}